/* istanbul ignore file */
// libs
import React from 'react';
import Sticky from 'react-sticky-el';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { stickySidebarMenuSx } from './sidebarMenuSx';

interface SidebarStickyMenuProps {
  children: React.ReactNode;
  avatar?: React.ReactElement;
  disabled?: boolean;
}

const SidebarStickyMenu = ({ avatar, children, disabled = false }: SidebarStickyMenuProps) => {
  const muiTheme = useTheme();
  const isMobileDevice = useMediaQuery(muiTheme.breakpoints.down('sm'));

  return (
    <Box sx={{ '& .sticky-menu': { mt: '90px' } }}>
      {avatar && (
        <Box
          sx={theme => ({
            position: 'relative',
            display: 'block',
            width: 'calc(100% - 60px)',
            maxWidth: '300px',
            pt: '250px',
            m: '0 0 20px 10px',
            backgroundColor: 'background.default',
            [theme.breakpoints.up('md')]: { maxWidth: 'none' },
            '& img': {
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              transform: 'translate(-50%, -50%)',
            },
            '& i': {
              position: 'absolute',
              top: 'calc(50% - 10px)',
              left: 'calc(50% - 10px)',
              fontSize: '20px',
            },
          })}
        >
          {avatar}
        </Box>
      )}
      <Sticky
        disabled={isMobileDevice || disabled}
        stickyClassName="sticky-menu"
        boundaryElement=".page-content"
        hideOnBoundaryHit={false}
        topOffset={-100}
        bottomOffset={40}
      >
        <Box className="sticky-sidebar-menu tabs-container" sx={stickySidebarMenuSx}>
          <ul>{children}</ul>
        </Box>
      </Sticky>
    </Box>
  );
};

export default SidebarStickyMenu;
